namespace Portico.Models.Legacy {
    
    export class PatientSearchRequestModel {
        maxResults: number;
        skipRows: number;
        firstNameQueryType: FirstNameQueryTypeEnum;
        firstName: string;
        lastNameQueryType: LastNameQueryTypeEnum;
        lastName: string;
        dateOfBirth: string;
        city: string;
        state: string;
        postalCode: string;
        country: string;
        memberNumber: string;
        email: string;
        phone: string;

        constructor(obj?: Portico.Services.Legacy.EnrollmentService.Models.PatientSearchRequestModel){
            this.maxResults = null;
            this.skipRows = null;
            this.firstNameQueryType = null;
            this.firstName = null;
            this.lastNameQueryType = null;
            this.lastName = null;
            this.dateOfBirth = null;
            this.city = null;
            this.state = null;
            this.postalCode = null;
            this.country = null;
            this.memberNumber = null;
            this.email = null;
            this.phone = null;

            if(obj){
                this.maxResults = obj.maxResults || null;
                this.skipRows = obj.skipRows || null;
                this.firstNameQueryType = obj.firstNameQueryType || null;
                this.firstName = obj.firstName || null;
                this.lastNameQueryType = obj.lastNameQueryType || null;
                this.lastName = obj.lastName || null;
                this.dateOfBirth = obj.dateOfBirth || null;
                this.city = obj.city || null;
                this.state = obj.state || null;
                this.postalCode = obj.postalCode || null;
                this.country = obj.country || null;
                this.memberNumber = obj.memberNumber || null;
                this.email = obj.email || null;
                this.phone = obj.phone || null;
            }
        }

        public toModel(): Portico.Services.Legacy.EnrollmentService.Models.PatientSearchRequestModel {
            return {
                maxResults: this.maxResults,
                skipRows: this.skipRows,
                firstNameQueryType: this.firstNameQueryType,
                firstName: this.firstName,
                lastNameQueryType: this.lastNameQueryType,
                lastName: this.lastName,
                dateOfBirth: this.dateOfBirth,
                city: this.city,
                state: this.state,
                postalCode: this.postalCode,
                country: this.country,
                memberNumber: this.memberNumber,
                email: this.email,
                phone: this.phone,
            };
        }
    }   
}